<template>
  <div class="page" v-wechat-title="$route.meta.title='说·美食'">
    <div class="list">
      <div class='list-item border-box' v-for="(item,index) in root" @click="toCityArticle(item.bagtype,item.id)">
        <div class="list-item-top box">
          <img class="item-img flex" v-lazy="item.headimg" alt="">
          <div class="item-top-right flex">
            <div class="name hide">{{item.guide}}</div>
            <div class="date">{{item.time}}</div>
          </div>
        </div>
        <div class="list-item-tit hide">{{item.name}}</div>
        <div class="list-item-img loadBg">
          <span class="label">{{item.bagtype==3?'推文':'语音'}}</span>
           <span class="label-icon"  v-if="item.bagtype==0">
              <img src="../../assets/city_icon05.png" alt="">
           </span>
          <img class="img" v-lazy="item.tvideourl" alt="">
        </div>
        <div class="list-item-bot border-box box none">
          <div class="flex">
            <img class="icon" style="top:-.04rem;" src="../../assets/city_icon13.png" alt="">{{item.zan}}
          </div>
          <div class="flex">
            <img class="icon" src="../../assets/city_icon02.png" alt="">{{item.comment}}
          </div>
          <!--<div class="flex">-->
            <!--<img class="icon" src="../../assets/city_icon03.png" alt="">121-->
          <!--</div>-->
          <div class="flex">
            <img class="icon" src="../../assets/city_icon04.png" alt="">{{item.share}}
          </div>
        </div>
      </div>
    </div>

    <p class="load-tip">{{loadText}}</p>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>
</template>
<script>
  import {uploadUserBrowse,citySiteFood} from "@/service/getData";
  import {wxGetPosition,wxShareme, getCityInfo,} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import P400 from '../../components/P400'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        userInfo: {}, //用户信息
        cityInfo: { citycode: "1", city: "全国", address: "" },
        loadEnd: false, //数据加载结束则赋值为true
        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',
        page: 1, //附近的加载更多
        rows:5,
        root: [], //列表
        loadText: "加载更多",
        P400: 0, //系统维护中
      }
    },
    computed: {},

    created(){
      let self = this;
      this.$loading.show('数据加载中');
      this.userInfo = getStore("userInfo");
      this.code = this.$route.query.code;
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if (this.appKey) {
        this.appKey = encodeURIComponent(this.appKey);
        setStore("appKey", {"appKey": this.appKey});
      } else {
        setStore("appKey", {"appKey": ""});
      }

      let cityInfo = getStore("cityInfo");
      if (cityInfo == null || cityInfo.citycode == null || cityInfo.citycode == "") {
        getCityInfo(function (res) {
          self.latlng = res;
          self.cityInfo = { citycode: "1", city: "全国", address: "" };
          setStore("cityInfo",self.cityInfo);
          self.initData(self.page);
        });
      } else {
        this.cityInfo = getStore("cityInfo");
        wxGetPosition(function (res) {
          self.latlng = {lat: res.latitude, lng: res.longitude};
          self.initData(self.page);
        });
      }
      let history = getStore("history", 1) || "";
      if (history) {
        this.history = history.history
      }
      window.addEventListener("scroll",this.handleFun)
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun)
    },
    methods: {
      //初始化：获取景区数据
      async initData(page){
        this.$loading.hide();
        let res = await citySiteFood({
          TimeStamp: this.TimeStamp,
          code: this.code,
          page: page,
          rows: this.rows
        });

        if (res.errcode === '00000'){
          this.$loading.hide();
          this.total = res.data.total
          let root = res.data.root
          if (page >= Math.ceil(this.total / this.rows)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (root.length > 0) {
            this.root = [...this.root, ...root];
          } else {
            if (page == 1) {
              this.root = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }

          var share = res.data.share;
          let link = '/city-food-list?code=' + this.code + '&TimeStamp=' + this.TimeStamp + '&appKey=' + this.appKey;
          if(share == null){
            let title = '说美食';
            let desc = '讲人文 . 听趣史 . 说美食 . 游景区';
            let img = '';
            wxShareme(title, desc, img, link);
          }else {
            wxShareme(share.title,share.desc,share.logo,link);
          }
        }else {
          this.$loading.hide();
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.initData(page);
          });
        })
      },


  //跳转到推文页面
      toCityArticle(type,id){
        if(type==3){
          this.$router.push({
            path: `/city-article?${'id='+id+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
          });
        }else{
          this.$router.push({
            path: `/video-play?${'id='+id+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
          });
        }
      },


    },
    components: {P400},
    //格式化数据
    filters: {
      initNumber: function (num) {
        if (num > 10000) {
          num = (num / 10000).toFixed(2) + '万'
        } else if (num > 1000) {
          num = (num / 1000).toFixed(2) + '千'
        }
        return num;
      }
    }
  }

</script>

<style scoped>
  .page{padding:0 .26rem;background-color:#fff}
  .list-item{padding:.24rem .3rem 0;margin-top:.28rem;box-shadow:0 0.06rem 0.2rem #d8e6ef;border-radius: .1rem; }
  .list-item-top img{width: .88rem;height: .88rem;margin-right:.12rem;border-radius: 50%;object-fit: cover;}
  .item-top-right .name{margin-top: .12rem;font-size: .28rem;color: #84b8fc;}
  .date{margin-top:.12rem;font-size: .22rem;color: #999;}
  .list-item-img{position: relative;height: 2.74rem;margin-top: .26rem;border-radius: .1rem;overflow: hidden;}
  .list-item-tit{margin-top:.2rem;font-size: .3rem;color: #0b0b0b;}
  .label{position: absolute;top:.46rem;left:0;height:.36rem;padding-left: .15rem;padding-right: .2rem;font: .2rem/.36rem "Microsoft YaHei";background: #f7610b;color: #fff;border-radius: 0 .3rem .3rem 0;letter-spacing: .01rem;}
  .label-icon{position: absolute;top:50%;left: 50%;padding: .14rem .2rem .17rem;border-radius: .08rem;background: rgba(0,0,0,.6);-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);}
  .label-icon img{float:left;width: .56rem;height: auto;}
  .list-item-bot{ height: .86rem;padding-top: .28rem;padding-bottom: .3rem;font: .22rem/.28rem "Microsoft YaHei";color: #999;text-align: center;}
  .list-item-bot .icon{position:relative;display:inline-block;width: auto;height: .28rem;margin-right: .1rem;vertical-align: middle;}
  .list-item-bot .flex{border-right: 1px solid #ccc;}
  .list-item-bot .flex:last-child{border-right: none;}
</style>



// WEBPACK FOOTER //
// src/page/city-site/city-food-list.vue